/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'
import { loaderStore } from './loaderStore'

export default function GlobalLoaderHost() {
    const [activeMessages, setActiveMessages] = useState([])
    const [displayedText, setDisplayedText] = useState('')
    const [fadeState, setFadeState] = useState('in')

    useEffect(() => {
        const unsubscribe = loaderStore.subscribe((messages) => {
            setActiveMessages(messages)
        })
        return unsubscribe
    }, [])

    const getTargetMessage = (messages) => {
        if (!messages || messages.length === 0) return ''
        const userFetchMsg = messages.find((m) =>
            m.toLowerCase().includes('fetching user')
        )
        if (userFetchMsg) return userFetchMsg

        return messages[messages.length - 1] || 'Loading...'
    }

    const currentTarget = getTargetMessage(activeMessages)

    useEffect(() => {
        if (!currentTarget) {
            setDisplayedText('')
            return undefined
        }

        if (!displayedText) {
            setDisplayedText(currentTarget)
            setFadeState('in')
            return undefined
        }

        if (displayedText !== currentTarget) {
            setFadeState('out')
            const timer = setTimeout(() => {
                setDisplayedText(currentTarget)
                setFadeState('in')
            }, 180)
            return () => clearTimeout(timer)
        }

        return undefined
    }, [currentTarget, displayedText])

    if (activeMessages.length === 0 && !displayedText) {
        return null
    }

    return (
        <Box
            sx={{
                position: 'fixed',
                top: '76px',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 99999,
                pointerEvents: 'none',
                animation: 'loaderSlideDown 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
                '@keyframes loaderSlideDown': {
                    '0%': { opacity: 0, transform: 'translate(-50%, -12px)' },
                    '100%': { opacity: 1, transform: 'translate(-50%, 0)' },
                },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    px: 2.5,
                    py: 1.2,
                    borderRadius: '50px',
                    backgroundColor: 'var(--color-surface-1, #ffffff)',
                    color: 'var(--color-text, #0f172a)',
                    border: '1px solid var(--color-border, rgba(226, 232, 240, 0.8))',
                    boxShadow:
                        '0 10px 25px -5px rgba(0, 85, 162, 0.15), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                    backdropFilter: 'blur(12px)',
                    transition: 'all 0.3s ease',
                }}
            >
                <CircularProgress
                    size={18}
                    thickness={5}
                    sx={{ color: 'var(--color-primary, #0055a2)' }}
                />
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 600,
                        fontSize: '0.875rem',
                        letterSpacing: '0.01em',
                        whiteSpace: 'nowrap',
                        color: 'var(--color-text, #0f172a)',
                        transition: 'opacity 0.18s ease, transform 0.18s ease',
                        opacity: fadeState === 'in' ? 1 : 0,
                        transform:
                            fadeState === 'in'
                                ? 'translateY(0)'
                                : 'translateY(-4px)',
                    }}
                >
                    {displayedText || 'Loading...'}
                </Typography>
            </Box>
        </Box>
    )
}
